import { Component, NgZone, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpService } from 'app/services/http.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import ExcelExport from 'export-xlsx';
import { SETTINGS_FOR_EXPORT } from '../xlsxSettings';

@Component({
  selector: 'app-eventos',
  templateUrl: './eventos.component.html',
  styleUrls: ['./eventos.component.scss']
})
export class EventosComponent implements OnInit {

  eventos: any[] = []
  usuario: any;
  rango: any = [];

  desde: Date;
  hasta: Date;

  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private formBuilder: FormBuilder,
    private http: HttpService,
    private ngZone: NgZone,
  ) {
    this.usuario = JSON.parse(this.http.getLocalstorage('usuario'))

    let today = new Date()
    today.setHours(0, 0, 0)
    console.log('today', today);

    let tonigth = new Date()
    // tonigth.setDate(tonigth.getDate()-1)
    tonigth.setHours(23, 59, 59)
    console.log('tonigth', tonigth);

    this.rango.push(today)
    this.rango.push(tonigth)

    this.getEventos()
  }

  ngOnInit(): void {

  }

  async getEventos(): Promise<void> {


    const desde = new Date(this.rango[0]).getTime()
    const _hasta = new Date(this.rango[1])
    const hasta = new Date(_hasta.setHours(23, 59, 59)).getTime()

    console.log('desde', desde);
    console.log('hasta', hasta);

    this.eventos = await this.http.getEventosByEmpresa(this.usuario.Empresa._id, 0, desde, hasta);
    console.log('eventos', this.eventos);

    const rutaBase = this.http.rutaBase  
    this.eventos.forEach(e => {

      // Campor para la descarga Excel
      e._cliente = e.Cliente.Nombre
      e._instalacion = e.Instalacion.Nombre
      e._fecha = new Date(e.createdAt).toLocaleString()

      switch (e.Evento) {
        case 1: //Entra a turno
          // e.icono = `<span class="info-box-icon bg-blue"><i class="material-icons">arrow_forward</i></span>`
          e.mensaje = `<span class="pad"><b>${e.NombreGuardia} </b><br>Comienza turno ${e.Turno}</span>`
          e.msgPlano = `${e.NombreGuardia} Comienza turno ${e.Turno}`
          break;
        case 2: //Sale de turno
          // e.icono = `<span class="info-box-icon bg-green"><i class="material-icons">arrow_back</i></span>`
          e.mensaje = `<span class="pad"><b>${e.NombreGuardia} </b><br>Finaliza turno ${e.Turno}</span>`
          e.msgPlano = `${e.NombreGuardia} Finaliza turno ${e.Turno}`
          break;
        case 3: //Botón de panico
          // e.icono = `  <p-avatar icon="pi pi-exclamation-triangle" size="xlarge" [style]="{'background-color':'#ff0000', 'color': '#ffffff'}"></p-avatar>`
          e.mensaje = `<span class="pad"><b>Botón de pánico </b><br>Se presionó el botón de pánico</span>`
          e.msgPlano = `Se presionó el botón de pánico`
          break;
        case 4: //Mensaje
          // e.icono = `<span class="info-box-icon bg-blue"><i class="material-icons">email</i></span>`
          e.mensaje = `<span class="pad"><b>Mensaje</b><br>${e.Mensaje}</span>`
          e.msgPlano = `Mensaje: ${e.Mensaje}`
          break;
        case 5: //Imagen adjunta 

          let _ruta = e.Documento.path.split('../clientes/')[1]
          // let _ruta = e.Documento.path
          e.foto = rutaBase + _ruta
          e.mensaje = `<a class="pl-2" href="${e.foto}" target="_blank"><img height="100px" src="${e.foto}"/></a>`
          e.msgPlano = ``
          break;
        case 6: //Batería baja
          // e.icono = `<span class="info-box-icon bg-red "><i class="material-icons">battery_alert</i></span>`
          e.mensaje = `<span class="pad">Batería celular baja</span>`
          e.msgPlano = `Batería celular baja`
          break;
        case 7:  //inicia ronda
          // e.icono = `<span class="info-box-icon bg-green"><i class="material-icons">directions_walk</i></span>`
          e.mensaje = `<span class="pad"><b>${e.NombreGuardia} </b><br>Inicia Ronda</span><button type="button" value="Actualizar" title="Ver recorrido" (click)="linkInstalacion(${e.Instalacion._id}, ${e._i}, ${e.Evento})" class="btn btn-info btn-edit" data-target="#imodal" data-toggle="modal"><i class="ion-android-globe" aria-hidden="true"></i></button>`
          e.msgPlano = `${e.NombreGuardia}  Inicia Ronda`
          break;
        case 8: //finaliza ronda
          // e.icono = `<span class="info-box-icon bg-red"><i class="material-icons">directions_walk</i></span>`
          e.mensaje = `<span class="pad"><b>${e.NombreGuardia} </b><br>Finaliza Ronda</span>`
          e.msgPlano = `${e.NombreGuardia} Finaliza Ronda`
          break;
        case 9: // 
          // e.icono = `<span class="info-box-icon bg-red"><i class="material-icons">remove_red_eye</i></span>`
          // Libre
          break;
        case 10: //rechaza ronda 
          // e.icono = `<span class="info-box-icon bg-yellow"><i class="material-icons">cancel</i></span>`
          e.mensaje = `<span class="pad">Guardia rechaza realizar ronda</span>`
          break;
        case 11:  // no atiende ronda
          // e.icono = `<span class="info-box-icon bg-yellow"><i class="material-icons">timer_off</i></span>`
          e.mensaje = `<span class="ml-1">Guardia no atiende ronda</span>`


          break;
        case 12:  // Inicia ronda voluntaria
          // e.icono = `<span class="info-box-icon bg-green"><i class="material-icons">directions_walk</i></span>`
          e.mensaje = `<span class="pad"><b>${e.NombreGuardia} </b><br>Inicia Ronda Voluntaria</span>`
          break;
        case 13:  // Termina ronda voluntaria
          // e.icono = `<span class="info-box-icon bg-red"><i class="material-icons">directions_walk</i> </span>`
          e.mensaje = `<span class="pad"><b>${e.NombreGuardia} </b><br>Finaliza Ronda Voluntaria</span>`
          break;
        case 20:  // Apaga servicio GPS
          e.mensaje = `<span class="ml-1"> Guardia apaga servicio GPS</span>`
          break;

        case 21:  // Enciende servicio GPS
          e.mensaje = `<span class="ml-1"> Guardia enciende servicio GPS</span>`
          break;

        case 22:  // Activa modo avión
          e.mensaje = `<span class="ml-1"> Guardia activa modo avión</span>`
          break;

        case 23:  // Desactiva modo avión
          e.mensaje = `<span class="ml-1"> Guardia desactiva modo avión</span>`
          break;

        default:
          // e.icono = `<span class="info-box-icon bg-green"> <i class="material-icons">all_inclusive</i></span>`
          e.mensaje = `<span class="pad">Otro</span>`
          break;
      }

    });


    this.ngZone.run(() => { })
  }

  descargar() {
    console.log('descargar');
    const excelExport = new ExcelExport();

    let data = [{ data: this.eventos }]
    console.log('SETTINGS_FOR_EXPORT', SETTINGS_FOR_EXPORT);
    let now = new Date()
    let d = now.getDate()
    let M = now.getMonth() + 1
    let y = now.getFullYear()
    let h = now.getHours()
    let m = now.getMinutes()
    let filename = 'Eventos_' + d.toString() + M.toString() + y.toString() + '_' + h.toString() + M.toString()
    SETTINGS_FOR_EXPORT.fileName = filename

    SETTINGS_FOR_EXPORT.workSheets[0].sheetName = 'Eventos'

    let def = [
      {
        name: 'Evento',
        key: 'msgPlano',
        width: 40,
      },
      {
        name: 'Fecha',
        key: '_fecha',
        width: 20,
      },
      {
        name: 'Cliente',
        key: '_cliente',
        width: 30,
      },
      {
        name: 'Instalación',
        key: '_instalacion',
        width: 30,
      }
    ]

    SETTINGS_FOR_EXPORT.workSheets[0].tableSettings.data.headerDefinition = def
    excelExport.downloadExcel(SETTINGS_FOR_EXPORT, data);

  }

}
